<template>
  <a href="#" @click="_click($event)" v-bind:class="elementDef.CSSClass">{{ t(this.elementDef.Label) }}</a>
</template>

<script>
import ResourceGetter  from '../../../../../model/resource/getter/resource-getter'
import ResponseEvents  from '../../../../../model/event-handlers/response-bussines-rules-events'
import CartRefresh     from '../../../../../model/event-handlers/cart-refresh-event'
import interpretations from '../../../../../model/interpretations'
import Bootbox         from '../../../../../model/Bootbox'
import Swal            from 'sweetalert2/dist/sweetalert2.js'

export default {

  props: ['elementDef', 'def', 'rowData', 'updateDataRequest'],

  methods: {
    _click (event) {
      event.preventDefault()

      const process = () => {
        let resource = ResourceGetter.get(this.def.viewName),
            data     = this.$parent.getData()

        let where = this.def.getReplacedWhereCondition(this.rowData.ID)

        let args = {
          ruleType: 'Action',
          ruleName: this.elementDef.ViewName,
          where:    where,
          value:    data
        }
        resource
          .setDef(this.def)
          .callBusinessRule(args)
          .then((response) => {
            if (response.data && response.data.values.hasOwnProperty(ResponseEvents.cartRefresh) &&
              response.data.values[ResponseEvents.cartRefresh] === 1) {
              CartRefresh.exec()
            }

            if (response.data.messages) {
              Swal.fire(response.data.messages, '')
            }

            if (this.updateDataRequest) {
              this.updateDataRequest()
            }

            this.$emit('buttonClicked')
          })
          .catch((error) => {
            if (this.updateDataRequest) {
              this.updateDataRequest()
            }
            this.handleApiError(error)
          })
      }

      if (this.elementDef.Interpretation === interpretations.buttonS) {
        Bootbox.message    = this.$translate.text('cfm_confirm_message') +
          ' "' + this.$translate.text(this.elementDef.Label) + '" ?'
        Bootbox.title      = this.$translate.text('cfm_confirm') + ' ?'
        Bootbox.translator = this.$translate
        Bootbox.init(() => {
          process()
        })

      }
      else {
        process()
      }

    }
  }
}
</script>

<style scoped>
.add-to-cart {
  white-space: nowrap;
}

.add-to-cart a {
  margin-bottom: 3px;
}

.products .products-view .column-name.add-to-cart a.btn {
  width: auto;
}

</style>
